module.exports = "/images/aerial-7.jpg";